import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon, XIcon } from '../lib/icons';
const COMPARISON_DATA = [{
  situation: 'Tu alumno pregunta cómo funciona la sintonización',
  without: 'Improvisás en el momento',
  with: 'Protocolo completo listo. Paso a paso.'
}, {
  situation: 'Querés armar tu propio curso de Reiki',
  without: 'No sabés por dónde empezar',
  with: 'Estructura lista para dictar desde el día 1'
}, {
  situation: 'Te piden precio por una formación',
  without: 'Bajás la voz — no sabés qué decir',
  with: 'Script de presentación y precios. Ya está.'
}, {
  situation: 'Necesitás material para tus alumnos',
  without: 'Buscás en internet lo que no encontrás',
  with: 'Manual del alumno listo para entregar'
}, {
  situation: 'Querés tener tu propia escuela de Reiki',
  without: 'Se siente un sueño lejano',
  with: 'Protocolo de academia. Un paso a la vez.'
}];
export function ComparisonSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-148">
      <div className="container mx-auto max-w-4xl" data-id="element-149">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-150">
          <div className="text-center mb-10" data-id="element-151">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-152">
              🕊️ ¿QUÉ AGREGA EL KIT REIKI PROFESIONAL?
            </h2>
          </div>

          <div className="bg-[#111111] rounded-2xl border border-white/10 overflow-hidden shadow-xl" data-id="element-153">
            {/* Header */}
            <div className="grid grid-cols-1 md:grid-cols-3 bg-black/50 border-b border-white/10" data-id="element-154">
              <div className="p-4 md:p-5 hidden md:block" data-id="element-155">
                <span className="text-gray-400 font-bold text-sm uppercase tracking-wider" data-id="element-156">
                  Situación
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-b md:border-b-0 md:border-l border-white/10 bg-red-950/20" data-id="element-157">
                <span className="text-red-400 font-bold text-sm uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-158">
                  <XIcon className="w-4 h-4" data-id="element-159" /> Sin Kit
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-b md:border-b-0 md:border-l border-white/10 bg-[#eab308]/10" data-id="element-160">
                <span className="text-[#eab308] font-bold text-sm uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-161">
                  <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-162" /> Con Kit
                </span>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-white/5" data-id="element-163">
              {COMPARISON_DATA.map((row, idx) => <div key={idx} className="grid grid-cols-1 md:grid-cols-3 hover:bg-white/[0.02] transition-colors" data-id="element-164">
                  <div className="p-4 md:p-5 flex items-center" data-id="element-165">
                    <span className="text-white font-medium text-sm md:text-base" data-id="element-166">
                      {row.situation}
                    </span>
                  </div>
                  <div className="p-4 md:p-5 md:border-l border-white/5 flex items-center justify-center text-center bg-red-950/10" data-id="element-167">
                    <span className="text-gray-400 text-sm" data-id="element-168">{row.without}</span>
                  </div>
                  <div className="p-4 md:p-5 md:border-l border-white/5 flex items-center justify-center text-center bg-[#eab308]/5" data-id="element-169">
                    <span className="text-[#eab308] font-medium text-sm" data-id="element-170">
                      {row.with}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}